import {
	PropsWithChildren,
	ReactElement,
	RefObject,
	useEffect,
	useRef
} from "react";
import { FloatingActionButton } from "./FloatingActionButton";
import {
	MediaQueryKind,
	useToggle,
	useWorkspaceMediaQuery
} from "client/Hooks";
import { DropOver } from "../DropOver/DropOver";

export type FloatingActionMenuProps = {
	visibleOn?: "responsive" | "always";
	trackingId: string;
};

export const FloatingActionMenu = (props: PropsWithChildren<FloatingActionMenuProps>): ReactElement | null => {
	const {
		visibleOn = "responsive",
		trackingId,
		children
	} = props;

	const [isOpen, toggleIsOpen] = useToggle(false);
	const ref: RefObject<HTMLButtonElement | null> = useRef<HTMLButtonElement>(null);

	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	const isVisible: boolean = visibleOn !== "responsive" || isResponsive;

	useEffect(
		() => {
			if (isOpen && !isVisible) {
				toggleIsOpen(false);
			}
		},
		[
			isOpen,
			isVisible,
			toggleIsOpen
		]
	);

	if (!isVisible) {
		return null;
	}

	return (
		<>
			<FloatingActionButton
				onClick={toggleIsOpen}
				visibleOn={visibleOn}
				trackingId={trackingId}
				isActive={isOpen}
				ref={ref}
			/>

			{isOpen && ref.current && (
				<DropOver
					target={ref.current}
					onClose={() => toggleIsOpen(false)}
				>
					{children}
				</DropOver>
			)}
		</>
	);
};
FloatingActionMenu.displayNAme = "FloatingActionMenu";
